import EBarResourceBody from './EBarResourceBody';

export default EBarResourceBody;
